module.exports = __webpack_public_path__ + "img/p-1.fc8a3e50.png";